export const DEPARTMENTS = '/departments'
